import axios from "axios";

axios.defaults.baseURL = "https://indextopipsapi.stage.bridgespecialty.com/api/";

export const SetAxiosDefauls = () => {
  axios.interceptors.request.use(onRequestFulfilled, onRequestRejected);
  axios.interceptors.response.use(onResponseFulfilled, onResponseRejected);
}
const onRequestFulfilled = async(config) => {
  let token = sessionStorage.getItem('auth-token');
  let userId = sessionStorage.getItem('userId');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if(userId) {
  config.headers.userId = userId;
  }
  return Promise.resolve(config);
}

const onRequestRejected = (error) => {
  return Promise.reject(error);
}

const onResponseFulfilled = (config) => {
  return Promise.resolve(config)
}

const onResponseRejected = (error) => {
  return Promise.reject(error);
}
